"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _themes = require("../../style/themes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledLoader = _styledComponents.default.div`
  ${_styledSystem.margin}
  text-align: center;
  white-space: nowrap;
`;
StyledLoader.defaultProps = {
  theme: _themes.baseTheme
};
var _default = StyledLoader;
exports.default = _default;